// src/pages/organismos/instituto/ArchivoHistorico.jsx

const publicaciones = [
  { fecha: "15/11/2024", titulo: "Antonio Raymondi", autor: "Francisco Sialer" },
  { fecha: "06/08/2024", titulo: "La epica victoria de Junín", autor: "Francisco Sialer" },
  { fecha: "09/10/2023", titulo: "Garibaldi - Héroe de Dos Mundos", autor: "Francisco Sialer" },
  { fecha: "11/02/2023", titulo: "Q.·.H.·. Jorge Basadre - Una Parte de Su Vida", autor: "Francisco Sialer" },
  { fecha: "27/12/2022", titulo: "Masonería y Escultismo", autor: "Francisco Sialer G. - Baden Powel" },
  { fecha: "05/12/2022", titulo: "Vidas Paralelas de Christian Dam y Gonzales Prada", autor: "Juan C. Hilario Melgarejo" },
  { fecha: "25/11/2022", titulo: "Enrique Meiggs", autor: "Francisco Sialer" },
  { fecha: "15/10/2022", titulo: "Logias Masónicas en Santo Domingo", autor: "Juan José Ramirez Door" },
  { fecha: "20/03/2023", titulo: "Reseña de la 'Convención' de Instalación de la GLP en 1882", autor: "Francisco Sialer" },
];

const boletines = [
  { fecha: "16/09/2020", titulo: "Cuaderno de Obra 1", contenido: "Bandera en el Oriente - Primera Revista Masónica - El Comercio y el Pacto de la GLP y el Supremo Consejo - Logia Peace and Concorde 445 - Colegio Guadalupe - Sebastián Lorente - Donación de Antiguos Mandiles y Cuños - Antonio Arenas Merino - Carlos Yzaguirre Aguinaga y el Día de la Madre - Francisco Bolognesi Cervantes - Andres A. Cáceres - José Escalante Fuentes - Jorge Basadre Grohmann" },
  { fecha: "25/11/2021", titulo: "Cuaderno de Obra 2", contenido: "Una Logia en Iquique - Colegio Leoncio Prado - Sobre la Compra del Terreno del Templo del Callao - Dos de Mayo de 1866 - Ernesto López Mindreau - Francisco L. Crosby - Emilio Traverso Angeloni - José Saba Liborno - Federico Villarreal" },
];

const ArchivoHistorico = () => {
  return (
    <div className="animate-fade-in">
      <div className="text-center mb-16">
        <h3 className="font-serif text-3xl md:text-5xl text-white mb-4">Archivo Histórico</h3>
        <p className="text-gray-400 font-light max-w-2xl mx-auto">
          Repositorio digital de investigaciones, ensayos y documentos rescatados.
        </p>
      </div>

      {/* --- SECCIÓN: TEXTOS HISTÓRICOS (TAL CUAL LA DATA ENVIADA) --- */}
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-12 mb-24">
        
        {/* ARTÍCULO 1: Ferrocarril al Oriente */}
        <div className="bg-[#0a0a0a] border border-white/5 p-8 md:p-12 shadow-2xl">
          <span className="text-[#C5A059] text-[10px] tracking-[0.3em] uppercase block mb-2">16 de Setiembre</span>
          <h4 className="font-serif text-3xl text-white mb-8 border-b border-white/10 pb-4">Un Ferrocarril al Oriente</h4>
          
          <div className="prose prose-invert prose-sm md:prose-base max-w-none text-gray-300 font-light leading-relaxed text-justify">
            <p>
              Nuestra Augusta Institución, desde que llegó a nuestras tierras en los albores de nuestra independencia, siempre ha gravitado en la vida pública del país, en algunos momentos más que en otros, a través de las opiniones y realizaciones de sus miembros. Tanto así que forjó nuestra República. Del ARCHIVO HISTORICO de la G.·. L.·. P.·. , que el Instituto atesora y protege, hemos escogido una propuesta que confirma lo dicho y que fue presentada en el primer tercio del siglo pasado y que hoy cobra vigencia dentro de la geopolítica de integración nacional como con la décima economía del mundo: Brasil.
            </p>
            <p>
              Se trata de las "BASES (sic) DE UN PROYECTO DE CARÁCTER NACIONALISTA PARA LA CONSTRUCCION DEL FERROCARRIL AL ORIENTE" presentado en la R.·. L.·. S.·. Excélsior Nº 9 por el h.·. Juan Miguel Ruíz, técnico mecánico de profesión, iniciado el 9 de diciembre de 1926, y en aquel momento -1934- desempeñaba el cargo de Secretario de su amado Taller. 
            </p>
            <p>
              Lo que motivó a nuestro h.·. Ruíz a presentar este proyecto era la inminente firma de un contrato entre el Estado Peruano y una firma norteamericana, que se consideraba lesivo para los intereses del país. La propuesta de la empresa americana, denominada “Propuesta Davis”, consistía en la construcción de dicho ferrocarril en un lapso de 10 años, al término del cual se encargarían de su administración por el sistema de concesión por 99 años... Además solicitaban el otorgamiento de hasta 4 millones de has. de "tierras de montaña a perpetuidad".
            </p>
            <h5 className="font-serif text-[#C5A059] text-xl mt-8 mb-4">Consideraciones Generales</h5>
            <p>Nuestro hermano empieza afirmando contundentemente, subrayando el párrafo, que:</p>
            <blockquote className="border-l-2 border-[#C5A059] pl-4 italic text-white my-4">
              "No debe contratarse esta obra con entidad extranjera alguna… El verdadero sentido de nacionalismo así lo aconseja y el clamoroso estado de amutilamiento (sic) de la Patria así lo exige."
            </blockquote>
            <p>
              Sugiere que las fuentes de financiamiento deban provenir de impuestos ya establecidos, la cooperación de los particulares y la venta de terrenos que el ferrocarril incorpore en su trayecto. En el primer caso, indica que el impuesto "Pro-Desocupados" debe aplicarse íntegramente a la obra...
            </p>
            <p>
              Sin embargo este no es el final del aporte que nuestro hermano hizo a la sociedad a través de su amada Logia. El 3 de agosto de 1934 la R.·. L.·. S.·. EXCELSIOR Nº 9, dirige una Pl.·. al M.·. R.·. H.·. G.·. M.·. de la G.·. L.·. P.·., presentando el “Proyecto” y solicitando presida..."una Comisión…para apersonarse ante el Sr Presidente de la República R.·. H.·. Oscar R. Benavides a fin de solicitarle que antes de firmarse el Contrato, se tome en cuenta el Proyecto". ¡Todo esto sucedió en el año 1934!
            </p>
          </div>
        </div>

        {/* ARTÍCULO 2: Donaciones */}
        <div className="bg-[#0a0a0a] border border-white/5 p-8 md:p-12 shadow-2xl">
          <span className="text-[#C5A059] text-[10px] tracking-[0.3em] uppercase block mb-2">15 de Junio</span>
          <h4 className="font-serif text-3xl text-white mb-8 border-b border-white/10 pb-4">Páginas del Instituto</h4>
          
          <div className="prose prose-invert prose-sm md:prose-base max-w-none text-gray-300 font-light leading-relaxed text-justify mb-8">
            <p>
              Nuestros hh.·. , en acciones que nos honran, siguen acrecentando el acervo documentario y museístico con donaciones que nos enriquecen como Institución; como en los casos que presentamos.
            </p>
            <h5 className="font-serif text-[#C5A059] text-xl mt-6 mb-4">Museo</h5>
            <p>
              Hemos recibido un collarín de la L.·. North Devon Province que perteneció al R.·. H.·. George E. Williams, quien se desempeñó como Gran Secretario de dicha Gran Logia durante 39 años, desde 1924 a 1963; precisamente dicha joya data de 1924.
            </p>
            <p>Así mismo, las medallas de:</p>
            <ul className="list-disc pl-5 text-gray-400 marker:text-[#C5A059]">
              <li>Civil War Lodge of Research # 1865 AF&AM – Grand Lodge of Virginia.</li>
              <li>Washington Masons. Medalla Nº 13414.</li>
              <li>Alianza Fraternal Americana Nº 92 – Washington. XX Aniversario.</li>
            </ul>
            <p className="mt-6">
              Esta donación realizada por el R.·. H.·. Carlos Ponce Velasco, obrero de las canteras de la Logia Alianza Fraternal Americana Nº 92 – Washington, se suma a una anterior, realizada por el mismo Q.·. H.·., de medallas de Logias Americanas dentro de la cual destaca la correspondiente a la celebración del 275 Aniversario de la Gran Logia de Inglaterra.
            </p>
          </div>

          {/* Fotos de Medallas descritas en el artículo */}
          <div className="grid grid-cols-2 gap-4 border-t border-white/10 pt-6">
             <div className="bg-gray-900 aspect-square overflow-hidden border border-white/5">
                <img src="/museo/medallas/civil_war_virginia.jpg" alt="Civil War Lodge of Research" className="w-full h-full object-cover opacity-80 hover:opacity-100 transition-opacity" />
             </div>
             <div className="bg-gray-900 aspect-square overflow-hidden border border-white/5">
                <img src="/museo/medallas/washington_masons.jpg" alt="Washington Masons" className="w-full h-full object-cover opacity-80 hover:opacity-100 transition-opacity" />
             </div>
          </div>
        </div>

      </div>

      {/* --- SECCIÓN: PUBLICACIONES Y BOLETINES --- */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
        
        {/* Tabla de Publicaciones */}
        <div>
          <h4 className="font-serif text-2xl text-white mb-6 border-b border-white/10 pb-4">Publicaciones del Instituto</h4>
          <div className="flex flex-col gap-2">
            {publicaciones.map((pub, idx) => (
              <div key={idx} className="flex flex-col sm:flex-row justify-between sm:items-center bg-[#0a0a0a] hover:bg-white/[0.03] border-b border-white/5 p-4 transition-colors">
                <div className="flex-1">
                  <div className="text-[#C5A059] font-mono text-xs mb-1">{pub.fecha}</div>
                  <div className="text-white font-serif text-base md:text-lg mb-1">{pub.titulo}</div>
                  <div className="text-gray-400 text-xs font-light">{pub.autor}</div>
                </div>
                <div className="mt-3 sm:mt-0">
                  <a href={`/publicaciones/${pub.titulo.replace(/\s+/g, '_')}.pdf`} className="text-[10px] text-[#C5A059] hover:text-white uppercase tracking-widest border border-[#C5A059]/30 px-3 py-1">
                    Descargar
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Tabla de Boletines */}
        <div>
          <h4 className="font-serif text-2xl text-white mb-6 border-b border-white/10 pb-4">Boletines Oficiales</h4>
          <div className="flex flex-col gap-4">
            {boletines.map((bol, idx) => (
              <div key={idx} className="bg-[#0a0a0a] border border-white/5 p-6 hover:border-[#C5A059]/30 transition-colors">
                <div className="flex justify-between items-start mb-4 border-b border-white/5 pb-3">
                  <div>
                    <span className="text-white font-serif text-lg md:text-xl block">{bol.titulo}</span>
                    <span className="text-[#C5A059] font-mono text-xs">{bol.fecha}</span>
                  </div>
                  <button className="text-[10px] bg-white/5 text-white px-3 py-1 uppercase tracking-widest hover:bg-[#C5A059] hover:text-black transition-colors">
                    PDF
                  </button>
                </div>
                <p className="text-gray-400 text-sm font-light leading-relaxed">{bol.contenido}</p>
              </div>
            ))}
          </div>
        </div>

      </div>

    </div>
  );
};

export default ArchivoHistorico;